<ng-container *ngIf="currentPodcast && isVisible()">
    <div class="audio-footer" [class.corner]="isCorner()" *ngIf="!isMinimized()">
        <div class="audio-controls">
            <button (click)="toggleState()" title="Minimizar">−</button>
            <button (click)="setState(0)" *ngIf="isCorner()" title="Centralizar">⤒</button>
            <button (click)="setState(3)" title="Fechar">×</button>
        </div>
        <div *ngIf="state === 0" class="text-white text-center small px-5 mb-2">
            {{ currentPodcast?.title }}
        </div>
        <audio #audioPlayer controls controlsList="nodownload">
            <source [attr.src]="currentPodcast?.audioUrl" type="audio/mpeg">
            Seu navegador não suporta o player de áudio.
        </audio>
    </div>
    <button class="minimized-btn" [class.btn-corner]="isCorner()" *ngIf="isMinimized()" (click)="setState(1)">
        <i class="fa fa-volume-up" aria-hidden="true"></i>
    </button>
</ng-container>
